// extracted by mini-css-extract-plugin
export default {"tooltip":"RR-z","arrow":"SR-z"};